import { EstimateStatus } from '../api/portal-estimates.api';
import { EstimateSettingsFilters } from '../stores/estimates-filters.store';

export const EstimatesFilterSettings: Record<EstimateStatus, keyof EstimateSettingsFilters> = {
    [EstimateStatus.Open]: 'open',
    [EstimateStatus.Sold]: 'sold',
    [EstimateStatus.Dismissed]: 'dismissed',
};
